import { useQueryClient } from '@tanstack/react-query';
import { userApi } from 'api';
import { useGetMe } from 'api/user';
var useCheckNewRewards = function () {
    var getUnnoticed = userApi.useGetNewRewards().refetch;
    var queryClient = useQueryClient();
    var me = useGetMe().data;
    var checkNewRewards = function () {
        if (!(me === null || me === void 0 ? void 0 : me.features.challenges))
            return;
        getUnnoticed();
        queryClient.invalidateQueries(['rewards']);
    };
    return { checkNewRewards: checkNewRewards };
};
export default useCheckNewRewards;
